import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MFAOutcome, OneTimeRedemptionEverydaySpend } from '@rd/core/mfa/types';
import { HttpError, PointsTransaction } from '@rd/types';
import { EverydaySpendCheckoutFormData } from '../../types/checkout-form-data.type';

export const EverydaySpendActions = createActionGroup({
  source: 'Everyday Spend',
  events: {
    'Submit Checkout Form Data': props<{
      loyaltyProgramId: string;
      formData: EverydaySpendCheckoutFormData;
    }>(),
    'Clear Checkout Form Data': props<{
      loyaltyProgramId: string;
    }>(),
    'Submit Points Transfer': props<{
      loyaltyProgramId: string;
      formData: EverydaySpendCheckoutFormData;
    }>(),
    'Submit Points Transfer Success': props<{
      pointsTransaction: PointsTransaction;
    }>(),
    'Submit Points Transfer Failure': props<{
      error: HttpError;
    }>(),
    'Clear Points Transfer Error': emptyProps(),
    'Hydrate Redemption': props<{
      hydrationData: OneTimeRedemptionEverydaySpend;
      outcome: MFAOutcome;
    }>(),
  },
});
